export interface SystemConfig {
  id: number;
  restaurant_name: string;
  logo_url: string;
  restaurant_logo_url: string;
  logo_size: number;
  logo_placement: 'left' | 'center';
  template_version: string;
  is_active: boolean;
  receipt_header_text: string;
  receipt_footer_text: string;
  show_logo_on_receipt: boolean;
  created_at: string;
  updated_at: string;
}

export const DEFAULT_SYSTEM_CONFIG: SystemConfig = {
  id: 1,
  restaurant_name: 'Yawas Kebab',
  logo_url: '',
  restaurant_logo_url: '',
  logo_size: 140,
  logo_placement: 'left',
  template_version: '1.0.0',
  is_active: true,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
};
